(() => {
  const swiper = new Swiper(".corporate-case-studies .swiper", {
    loop: true,
    pagination: {
      el: ".corporate-case-studies .swiper-pagination",
    },
    navigation: {
      addIcons: false,
      nextEl: ".corporate-case-studies .swiper-button-next",
      prevEl: ".corporate-case-studies .swiper-button-prev",
    },
  });
})();
